import {ajaxPost,ajaxGet} from '../config/ajax.js';
import axios from 'axios';
import {baseUrl,queryAssetsUser,queryAssetsConf,queryAssetsType,queryNodeBase,queryBusiness,queryAssetsBase,downloadAssetsBase,
    assetsAdd,assetsUpdate,importAssets,importAssetsUpdate,queryChangeListByAssetsId,queryInspectinfoListByAssetsId,
    queryMaintaininfoListByAssetsId,updateMoreAssetsStatus,inspectMoreAssets,addinspect,addAssetsType,setAssetsConf,deleteAssetsConf,
    queryInspect,queryInspectId,downloadInspect,deleteInspect,queryMaintain,bar_code,maintainAdd,downloadMaintain,queryMaintainId,
    deleteMaintain,queryInspectionRecord,importMaintain,queryMaintainName,updateAssetsType,deleteAssetsType,updateAssetsConf,
    queryAssetsSpecifications,queryAssetsNames,queryAssetsManufacturers,queryNodeBase2,parseMonLog,queryTableName,getFileState,
    queryFtpMonLog,getParseType,analysisDataMon,setByFtpId,queryErrorData,downloadErrorData,deleteErrorLogData,queryErrorLogType,
    queryUploadFilesByFtpId,parseMonLogForRecently,downloadErrorLog,queryChangeLogList,downloadChangeLog,queryChangeItem,
    deleteParseMonLogById,queryNodeDetailType,deleteAllErrorData,queryFilePath,addErrorDateRemark, queryChildAssetsBaseByParentId,
    // queryAssetsBaseByAssetsId
    queryAssetsPdNodeList, queryAssetsPdInfo, updateAssetsPdInfo, updateAssetsPdNodeState, exportAssetsPd, getAssetsPdGroup,
    updateAssetsPdNameState, querySsqyList, querySsqySsrList, queryCyNodeList, queryCysbNode, deleteSssbById, querySbInfoList, 
    editSsqyInfo, editSssbInfo, editCollectionInfo, editInvoiceInfo, setCollection, setColInvoice, querySsqyXxflList, addSsInfos, 
    zhdiotLogin, zhdiotStart, queryCysbCollectionInfos, queryCollectionDetails, exportCysbSsqyInfo, exportCysbCollectionInfos,
    deleteCollection, exportKpsqdWord, exportCysbCollectionDetails, setname, exportMaintain, updateSsqyState, getsssbOnlineStat,
    getOfflineSbList, exportOfflineSbList, exportOfflineNodeNumList, queryPdListByAssetsId
    } from "../address/url";

export const QueryFilePath = function(){
    return ajaxGet(queryFilePath)
}
// 查询 所有资产用户信息（需要确定用户类型类型）
export const QueryAssetsUser = function(params) {
    return ajaxGet(queryAssetsUser +'?'+ params)
}
// 查询 资产状态、所属期 等查询条件下拉框
export const QueryAssetsConf = function(params) {
    return ajaxGet(queryAssetsConf +'?'+ params)
}
// 查询 资产类型树
export const QueryAssetsType = function(params) {
    return ajaxGet(queryAssetsType +'?'+ params)
}
// 查询 所有节点
export const QueryNodeBase = function(params) {
    return ajaxGet(queryNodeBase +'?'+ params)
}
// 查询 所有节点 --- 新增
export const QueryNodeBase2 = function(params) {
    return ajaxGet(queryNodeBase2 +'?'+ params)
}
// 查询 所有商户
export const QueryBusiness = function(params) {
    return ajaxGet(queryBusiness +'?'+ params)
}
// 查询资产信息
export const QueryAssetsBase  = function(params) {
    return ajaxPost(queryAssetsBase,params)
}
// 导出资产信息
// export const DownloadAssetsBase  = function(params) {
//     return ajaxPost(downloadAssetsBase,params)
// }
export const exportExcel = function(form) {
    return axios({ // 用axios发送post请求
        method: 'post',
        url: downloadAssetsBase, // 请求地址
        data: form, // 参数
        // responseType: 'blob', // 表明返回服务器返回的数据类型
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
// 新增资产
export const AssetsAdd  = function(params) {
    return ajaxPost(assetsAdd,params)
}
// 修改资产
export const AssetsUpdate  = function(params) {
    return ajaxPost(assetsUpdate,params)
}
// 资产批量导入 -- 新增
export const ImportAssets  = function(params) {
    return ajaxPost(importAssets,params)
}
// 资产批量导入 -- 修改
export const ImportAssetsUpdate  = function(params) {
    return ajaxPost(importAssetsUpdate,params)
}
// 资产--查询变更记录
export const QueryChangeListByAssetsId  = function(params) {
    return ajaxPost(queryChangeListByAssetsId,params)
}
//  资产--查询巡检记录
export const QueryInspectinfoListByAssetsId  = function(params) {
    return ajaxPost(queryInspectinfoListByAssetsId,params)
}
//  资产--查询维修记录
export const QueryMaintaininfoListByAssetsId  = function(params) {
    return ajaxPost(queryMaintaininfoListByAssetsId,params)
}
// 资产--查询所属资产
export const QueryChildAssetsBaseByParentId  = function(params) {
    return ajaxPost(queryChildAssetsBaseByParentId,params)
}
// 批量变更
export const UpdateMoreAssetsStatus  = function(params) {
    return ajaxPost(updateMoreAssetsStatus,params)
}
// 批量巡检
export const InspectMoreAssets  = function(params) {
    return ajaxPost(inspectMoreAssets,params)
}
// 新增巡检
export const Addinspect  = function(params) {
    return ajaxPost(addinspect,params)
}
// 新增资产类型
export const AddAssetsType  = function(params) {
    return ajaxPost(addAssetsType,params)
}
// 配置资产-新增 资产状态、部件名称、所属期
export const SetAssetsConf  = function(params) {
    return ajaxPost(setAssetsConf,params)
}
//配置资产-《删除》 资产状态、部件名称、所属期
export const DeleteAssetsConf  = function(params) {
    return ajaxPost(deleteAssetsConf,params)
}
// 查询巡检信息
export const QueryInspect  = function(params) {
    return ajaxPost(queryInspect,params)
}
// 根据巡检id查看巡检信息以及巡检记录
export const QueryInspectId  = function(params) {
    return ajaxPost(queryInspectId,params)
}
// 导出巡检信息
// export const DownloadInspect  = function(params) {
//     return ajaxPost(downloadInspect,params)
// }
export const DownloadInspect = function(form) {
    return axios({ // 用axios发送post请求
        method: 'post',
        url: downloadInspect, // 请求地址
        data: form, // 参数
        // responseType: 'blob', // 表明返回服务器返回的数据类型
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
// 删除巡检记录
export const DeleteInspect  = function(params) {
    return ajaxPost(deleteInspect,params)
}
// 查询维修信息
export const QueryMaintain  = function(params) {
    return ajaxPost(queryMaintain,params)
}
// 导出维修信息
export const ExportMaintain = function(form) {
    return axios({ // 用axios发送post请求
        method: 'post',
        url: exportMaintain, // 请求地址
        data: form, // 参数
        // responseType: 'blob', // 表明返回服务器返回的数据类型
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
// 根据条码号查询设备名称
export const Bar_code  = function(params) {
    return ajaxPost(bar_code,params)
}
// 新增维修记录传资产id
export const MaintainAdd  = function(params) {
    return ajaxPost(maintainAdd,params)
}
// 导出维修记录
// export const DownloadMaintain  = function(params) {
//     return ajaxPost(downloadMaintain,params)
// }
export const DownloadMaintain = function(form) {
    return axios({ // 用axios发送post请求
        method: 'post',
        url: downloadMaintain, // 请求地址
        data: form, // 参数
        // responseType: 'blob', // 表明返回服务器返回的数据类型
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
// 根据巡检id查看维修信息以及维修记录
export const QueryMaintainId  = function(params) {
    return ajaxPost(queryMaintainId,params)
}
// 删除维修记录
export const DeleteMaintain  = function(params) {
    return ajaxPost(deleteMaintain,params)
}
// 查看个人的巡检记录
export const QueryInspectionRecord  = function(params) {
    return ajaxPost(queryInspectionRecord,params)
}
// 维修导入
export const ImportMaintain  = function(params) {
    return ajaxPost(importMaintain,params)
}
// 维修新增输入条码号
export const QueryMaintainName  = function(params) {
    return ajaxPost(queryMaintainName,params)
}
// 修改资产类型
export const UpdateAssetsType  = function(params) {
    return ajaxPost(updateAssetsType,params)
}
// 删除资产类型
export const DeleteAssetsType  = function(params) {
    return ajaxPost(deleteAssetsType,params)
}
// 配置资产-《修改》 资产状态、部件名称、所属期
export const UpdateAssetsConf  = function(params) {
    return ajaxPost(updateAssetsConf,params)
}
// 查询所有资产规格
export const QueryAssetsSpecifications = function(params) {
    return ajaxGet(queryAssetsSpecifications +'?'+ params)
}
// 查询所有资产名称
export const QueryAssetsNames = function(params) {
    return ajaxGet(queryAssetsNames +'?'+ params)
}
// 查询所有资产生产厂家
export const QueryAssetsManufacturers = function(params) {
    return ajaxGet(queryAssetsManufacturers +'?'+ params)
}
//解析运行日志
export const ParseMonLog = function(params) {
    return ajaxPost(parseMonLog,params)
}
// 表名下拉菜单
export const QueryTableName = function(params) {
    return ajaxGet(queryTableName +'?'+ params)
}
//ftp文件日志
export const QueryFtpMonLog = function(params) {
    return ajaxPost(queryFtpMonLog,params)
}
// 任务环节下拉getFileState
export const GetParseType = function(params) {
    return ajaxGet(getParseType +'?'+ params)
}
// 状态
export const GetFileState = function(params) {
    return ajaxGet(getFileState +'?'+ params)
}
// 解析数据监控
export const AnalysisDataMon = function(params) {
    return ajaxPost(analysisDataMon, params)
}
//设置
export const SetByFtpId = function(params) {
    return ajaxPost(setByFtpId,params)
}
//对照管理
export const QueryErrorData = function(params) {
    return ajaxPost(queryErrorData,params)
}
//导出缺对照数据
export const DownloadErrorData = function(form) {
    return axios({ // 用axios发送post请求
        method: 'post',
        url: downloadErrorData, // 请求地址
        data: form, // 参数
        // responseType: 'blob', // 表明返回服务器返回的数据类型
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
//操作缺对照数据
export const DeleteErrorLogData = function(params) {
    return ajaxPost(deleteErrorLogData,params)
}
//缺对照日志类型条件下拉
export const QueryErrorLogType = function(params) {
    return ajaxGet(queryErrorLogType +'?'+ params)
}
//最近文件上传情况
export const QueryUploadFilesByFtpId = function(params) {
    return ajaxPost(queryUploadFilesByFtpId,params)
}
//最近15条解析情况
export const ParseMonLogForRecently = function(params) {
    return ajaxPost(parseMonLogForRecently,params)
}
// 下载
export const  DownloadErrorLog  = function(params) {
    return ajaxPost(downloadErrorLog,params)
}
//变更管理列表
export const QueryChangeLogList = function(params) {
    return ajaxPost(queryChangeLogList,params)
}
//  变更管理 下载导出
export const DownloadChangeLog = function(form) {
    return axios({ // 用axios发送post请求
        method: 'post',
        url: downloadChangeLog, // 请求地址
        data: form, // 参数
        // responseType: 'blob', // 表明返回服务器返回的数据类型
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
//变更内容
export const QueryChangeItem = function(params) {
    return ajaxGet(queryChangeItem +'?'+ params)
}
//解析运行日志  失败导出
export const DeleteParseMonLogById = function(params) {
    return ajaxPost(deleteParseMonLogById,params)
}
// 解析运行日志  对照管理  节点
export const QueryNodeDetailType = function(params) {
    return ajaxGet(queryNodeDetailType +'?'+ params)
}
// 解析运行日志  对照管理  全部删除
export const DeleteAllErrorData = function(params) {
    return ajaxPost(deleteAllErrorData,params)
}
//添加备注
export const AddErrorDateRemark = function(params) {
    return ajaxPost(addErrorDateRemark,params)
}
// 盘点记录
export const QueryPdListByAssetsId = function(params) {
    return ajaxPost(queryPdListByAssetsId, params)
}
//  
// export const QueryAssetsBaseByAssetsId = function(params) {
//     return ajaxPost(queryAssetsBaseByAssetsId,params)
// }
// ----盘点管理
// 查询盘点节点列表
export const QueryAssetsPdNodeList = function(params) {
    return ajaxGet(queryAssetsPdNodeList +'?'+ params)
}
// 查询盘点信息
export const QueryAssetsPdInfo = function(params) {
    return ajaxGet(queryAssetsPdInfo +'?'+ params)
}
// 修改盘点信息
export const UpdateAssetsPdInfo = function(params) {
    return ajaxPost(updateAssetsPdInfo,params)
}
// 修改节点状态
export const UpdateAssetsPdNodeState = function(params) {
    return ajaxPost(updateAssetsPdNodeState,params)
}
// 导出盘点信息
export const ExportAssetsPd = function(form) {
    return axios({ // 用axios发送post请求
        method: 'post',
        url: exportAssetsPd, // 请求地址
        data: form, // 参数
        // responseType: 'blob', // 表明返回服务器返回的数据类型
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
//盘点信息搜索条件 
export const GetAssetsPdGroup = function(params) {
    return ajaxGet(getAssetsPdGroup)
}
// 关闭盘点信息1是关闭，0是开启
export const UpdateAssetsPdNameState = function(params) {
    return ajaxPost(updateAssetsPdNameState,params)
}
// 设备运维
// 查询实施企业列表
export const QuerySsqyList = function(params) {
    return ajaxPost(querySsqyList, params)
}
// 查询实施人下拉框
export const QuerySsqyXxflList = function(params) {
    return ajaxGet(querySsqyXxflList)
}
// 查询企业详细分类
export const QuerySsqySsrList = function(params) {
    return ajaxGet(querySsqySsrList + params)
}
// 查询所有企业列表
export const QueryCyNodeList = function(params) {
    return ajaxPost(queryCyNodeList, params)
}
// 查询实施企业信息&付款单&发票信息
export const QueryCysbNode = function(params) {
    return ajaxPost(queryCysbNode, params)
}
// 删除实施设备
export const DeleteSssbById = function(params) {
    return ajaxPost(deleteSssbById, params)
}
// 查询设备基础信息
export const QuerySbInfoList = function(params) {
    return ajaxPost(querySbInfoList, params)
}
// 新增/编辑 实施企业信息
export const EditSsqyInfo = function(params) {
    return ajaxPost(editSsqyInfo, params)
}
// 新增/编辑 实施设备信息(单个)
export const EditSssbInfo = function(params) {
    return ajaxPost(editSssbInfo, params)
}
// 新增/编辑 实施设备信息(多个)
export const AddSsInfos = function(params) {
    return ajaxPost(addSsInfos, params)
}
// 自动获取监控地址
export const ZhdiotLogin = function(params) {
    return ajaxGet(zhdiotLogin +'?'+ params)
}
export const ZhdiotStart = function(params) {
    return ajaxGet(zhdiotStart +'?'+ params)
}
export const Setname = function(params) {
    return ajaxGet(setname +'?'+ params)
}
// 
// 导出设备
export const ExportCysbSsqyInfo = function(form) {
    return axios({ // 用axios发送post请求
        method: 'post',
        url: exportCysbSsqyInfo, // 请求地址
        data: form, // 参数
        // responseType: 'blob', // 表明返回服务器返回的数据类型
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
// 结算管理
// 
// 查询结算单&发票信息列表
export const QueryCysbCollectionInfos = function(params) {
    return ajaxPost(queryCysbCollectionInfos, params)
}
// 列表付款单详情（悬浮）
export const QueryCollectionDetails = function(params) {
    return ajaxGet(queryCollectionDetails +'?'+ params)
}
// 新增/编辑 收款单
export const EditCollectionInfo = function(params) {
    return ajaxPost(editCollectionInfo, params)
}
// 发票信息保存
export const EditInvoiceInfo = function(params) {
    return ajaxPost(editInvoiceInfo, params)
}
// 已收款&开发票
export const SetCollection = function(params) {
    return ajaxPost(setCollection, params)
}
// 开票状态&邮寄状态
export const SetColInvoice = function(params) {
    return ajaxPost(setColInvoice, params)
}
// 导出结算
export const ExportCysbCollectionInfos = function(form) {
    return axios({ // 用axios发送post请求
        method: 'post',
        url: exportCysbCollectionInfos, // 请求地址
        data: form, // 参数
        // responseType: 'blob', // 表明返回服务器返回的数据类型
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
// 删除未付款结算
export const DeleteCollection = function(params) {
    return ajaxGet(deleteCollection +'?'+ params)
}
// 导出发票信息
export const ExportKpsqdWord = function(form) {
    return axios({ // 用axios发送post请求
        method: 'post',
        url: exportKpsqdWord, // 请求地址
        data: form, // 参数
        // responseType: 'blob', // 表明返回服务器返回的数据类型
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
// 导出设备明细
export const ExportCysbCollectionDetails = function(form) {
    return axios({ // 用axios发送post请求
        method: 'post',
        url: exportCysbCollectionDetails, // 请求地址
        data: form, // 参数
        // responseType: 'blob', // 表明返回服务器返回的数据类型
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
// 改实施企业状态
export const UpdateSsqyState = function(params) {
    return ajaxPost(updateSsqyState, params)
}
// 设备运维统计
export const GetsssbOnlineStat = function(params) {
    return ajaxGet(getsssbOnlineStat +'?'+ params)
}
// 设备运维不在线列表
export const GetOfflineSbList = function(params) {
    return ajaxPost(getOfflineSbList, params)
}
// 设备运维不在线列表导出
export const ExportOfflineSbList = function(form) {
    return axios({ // 用axios发送post请求
        method: 'post',
        url: exportOfflineSbList, // 请求地址
        data: form, // 参数
        // responseType: 'blob', // 表明返回服务器返回的数据类型
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
// 设备运维不在线企业数量导出
export const ExportOfflineNodeNumList = function(form) {
    return axios({ // 用axios发送post请求
        method: 'post',
        url: exportOfflineNodeNumList, // 请求地址
        data: form, // 参数
        // responseType: 'blob', // 表明返回服务器返回的数据类型
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'application/json'
        }
    })
}


// WEBPACK FOOTER //
// ./src/js/traceEquipment/traceEquipment.js